import React from 'react';
import PropTypes from 'prop-types';
import { CLAIM_TYPES } from 'products/nomad_insurance/views/ClaimsForm/consts';
import { SummaryField, SummaryBox } from '../../styled';

const PreEx = ({ claimType, hasPreEx, startComment }) => {
  if (claimType !== CLAIM_TYPES.MEDICAL) {
    return null;
  }
  return (
    <>
      <SummaryField>
        <div>
          <b>Do you think this condition is linked to previous event / condition?</b>
        </div>
        <div>{hasPreEx ? 'Yes' : 'No'}</div>
      </SummaryField>
      {hasPreEx && (
        <SummaryField>
          <div>
            <b>How did the illness or injury begin?</b>
          </div>
          <SummaryBox>{startComment}</SummaryBox>
        </SummaryField>
      )}
    </>
  );
};

PreEx.propTypes = {
  claimType: PropTypes.string.isRequired,
  hasPreEx: PropTypes.bool,
  startComment: PropTypes.string
};

export default PreEx;
